/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightPaymentOperationApprovalResponse
 */
export interface FlightPaymentOperationApprovalResponse {
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    paymentOperationId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    operationType: FlightPaymentOperationApprovalResponseOperationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    amountMinor: number;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    state: FlightPaymentOperationApprovalResponseStateEnum;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    evidenceDigest: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    approverUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    approverEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof FlightPaymentOperationApprovalResponse
     */
    approvedAt: Date;
}


/**
 * @export
 */
export const FlightPaymentOperationApprovalResponseOperationTypeEnum = {
    AuthorizationRelease: 'authorization_release',
    CustomerRefund: 'customer_refund'
} as const;
export type FlightPaymentOperationApprovalResponseOperationTypeEnum = typeof FlightPaymentOperationApprovalResponseOperationTypeEnum[keyof typeof FlightPaymentOperationApprovalResponseOperationTypeEnum];

/**
 * @export
 */
export const FlightPaymentOperationApprovalResponseStateEnum = {
    Approved: 'approved'
} as const;
export type FlightPaymentOperationApprovalResponseStateEnum = typeof FlightPaymentOperationApprovalResponseStateEnum[keyof typeof FlightPaymentOperationApprovalResponseStateEnum];


/**
 * Check if a given object implements the FlightPaymentOperationApprovalResponse interface.
 */
export function instanceOfFlightPaymentOperationApprovalResponse(value: object): value is FlightPaymentOperationApprovalResponse {
    if (!('paymentOperationId' in value) || value['paymentOperationId'] === undefined) return false;
    if (!('operationType' in value) || value['operationType'] === undefined) return false;
    if (!('amountMinor' in value) || value['amountMinor'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('evidenceDigest' in value) || value['evidenceDigest'] === undefined) return false;
    if (!('approverUserId' in value) || value['approverUserId'] === undefined) return false;
    if (!('approverEmail' in value) || value['approverEmail'] === undefined) return false;
    if (!('approvedAt' in value) || value['approvedAt'] === undefined) return false;
    return true;
}

export function FlightPaymentOperationApprovalResponseFromJSON(json: any): FlightPaymentOperationApprovalResponse {
    return FlightPaymentOperationApprovalResponseFromJSONTyped(json, false);
}

export function FlightPaymentOperationApprovalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPaymentOperationApprovalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentOperationId': json['payment_operation_id'],
        'operationType': json['operation_type'],
        'amountMinor': json['amount_minor'],
        'currency': json['currency'],
        'state': json['state'],
        'evidenceDigest': json['evidence_digest'],
        'approverUserId': json['approver_user_id'],
        'approverEmail': json['approver_email'],
        'approvedAt': (new Date(json['approved_at'])),
    };
}

export function FlightPaymentOperationApprovalResponseToJSON(json: any): FlightPaymentOperationApprovalResponse {
    return FlightPaymentOperationApprovalResponseToJSONTyped(json, false);
}

export function FlightPaymentOperationApprovalResponseToJSONTyped(value?: FlightPaymentOperationApprovalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_operation_id': value['paymentOperationId'],
        'operation_type': value['operationType'],
        'amount_minor': value['amountMinor'],
        'currency': value['currency'],
        'state': value['state'],
        'evidence_digest': value['evidenceDigest'],
        'approver_user_id': value['approverUserId'],
        'approver_email': value['approverEmail'],
        'approved_at': value['approvedAt'].toISOString(),
    };
}

